const AccountPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/AccountPage");
const ProfilePage = () =>
  import(/* webpackChunkName: "account" */ "./containers/ProfilePage");
const FinancePage = () =>
  import(/* webpackChunkName: "account" */ "./containers/FinancePage");
const DealsPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/DealsPage");
const RequestsPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/RequestsPage");
const HistoryPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/HistoryPage");
const NotificationsPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/NotificationsPage");
const AmlBasePage = () =>
  import(/* webpackChunkName: "account" */ "./containers/AmlBase");
const AmlInvestigationPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/AmlInvestigation");
const VerificationPage = () =>
  import(/* webpackChunkName: "account" */ "./containers/VerificationPage");

export default {
  path: "/account",
  name: "account",
  redirect: { name: "profile" },
  component: AccountPage,
  children: [
    {
      path: "profile",
      name: "profile",
      component: ProfilePage,
    },
    {
      path: "finance",
      name: "finance",
      component: FinancePage,
      children: [
        {
          path: "repl-success",
          redirect: { name: "finance", query: { "repl-modal": "success" } },
        },
        {
          path: "repl-failure",
          redirect: { name: "finance", query: { "repl-modal": "failure" } },
        },
      ],
    },
    {
      path: "deals",
      name: "deals",
      component: DealsPage,
    },
    {
      path: "requests",
      name: "requests",
      component: RequestsPage,
    },
    {
      path: "history",
      name: "history",
      component: HistoryPage,
    },
    {
      path: "notifications",
      name: "notifications",
      component: NotificationsPage,
    },
    {
      path: "aml-base",
      name: "aml-base",
      component: AmlBasePage,
    },
    {
      path: "aml-investigation",
      name: "aml-investigation",
      component: AmlInvestigationPage,
    },
    {
      path: "verification",
      name: "verification",
      component: VerificationPage,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/Account/routes.js